import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { PatientService as SharedPatientService } from '@avanta/shared/services/patients';
import { type Patient } from '@avanta/shared/types/patients';
import { type User } from '@avanta/shared/types/users';
import { type AxiosResponse } from 'axios';
import { getUserId } from 'utils/storage';

const PATIENTS_URL = `${BASE_URL}patients`;

export type PatientServiceTypes = {
  getPatient: (patientId?: string) => Promise<AxiosResponse<User>>;
  updatePatient: (patient: Patient) => Promise<void>;
  deletePatient: (userId: string, redirect?: boolean) => Promise<void>;
  updateBookingInfo: (patient: Patient) => Promise<void>;
};

export const PatientService: PatientServiceTypes = {
  getPatient: SharedPatientService.getPatient,
  updatePatient: SharedPatientService.updatePatient,
  deletePatient: SharedPatientService.deletePatient,
  updateBookingInfo: async patient =>
    service.put(`${PATIENTS_URL}/${getUserId()}/booking`, patient),
};
